import React from 'react'

const HomeWhoWeAre = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-3'>
            <div className=''>
                <text className='fs-ss-32 text-montserrat fw-700 text-ss-primary'>
                    Who Are We?
                    <hr className='hr-style my-1' style={{ width:'50px', marginTop:'0px', marginBottom:'4px'}}/>
                </text>
            </div>

            <div className='pt-1'>
                <text className='fs-ss-20 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic'}}>
                    Quick & Comprehensive Lab Testing Service Provider
                </text>
            </div>

            <div className='pt-3'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Take charge of your well-being with United Lab Care—the ultimate destination for comprehensive lab testing services. Our mission is to empower you to lead healthier lives through easy access to innovative laboratory testing and health screening services. Whether you need Covid-19, Influenza, or RSV testing, our state-of-the-art facilities provide accurate results with a remarkable 97% accuracy rate, all from a single swab test that can diagnose up to 19 viruses.
                </text>
            </div>

            <div className='py-4'>
                <text className='fs-ss-16 text-montserrat fw-600' style={{ letterSpacing:'0.5px'}}>
                    But that’s not all we offer. At United Lab Care, we understand that your health is multidimensional, so we go beyond viral testing. Our extensive services include blood, toxicology, and STI/STD testing. Our team of highly skilled healthcare professionals in Chicago is dedicated to providing you with a comfortable and seamless experience throughout your testing journey.
                </text>
            </div>

            <div className=''>
                <text className='fs-ss-16 text-montserrat fw-600' style={{ letterSpacing:'0.5px'}}>
                        Taking care of your health can sometimes be overwhelming, but with United Lab Care by your side, it doesn’t have to be. Our user-friendly approach and cutting-edge technology make getting the tests you need a breeze—no more stress or confusion—just reliable results and peace of mind. Your health matters, and we’re here to support you every step of the way. So, say goodbye to uncertainty and embrace the power of knowledge with United Lab Care. Take the first step towards a healthier future today!
                </text>
            </div>


        </div>
    </div>
  )
}

export default HomeWhoWeAre